module.exports = __webpack_public_path__ + "static/media/atom.37d142d6.svg";